module.exports = __webpack_public_path__ + "img/cogs@2x.7598c6c4.png";